export default "__VITE_ASSET__CdsMgK1q__"